import type { ReactElement } from 'react';
import { LanguageSelectorFull } from '@provider-directory/components/language-selector/language-selector-full.component';
import { WhiteplainsHeader } from './whiteplains-header';

export function MontefioreWphHeaderWrapper(_props: {
  className?: string;
}): ReactElement {
  return (
    <div className={'border-b border-b-black border-opacity-10 print:hidden'}>
      <LanguageSelectorFull />
      <WhiteplainsHeader />
    </div>
  );
}
